import { memo, useState } from 'react';
import { DoubleLeftOutlined } from '@ant-design/icons';
import cx from 'classnames';
import { Button } from '@ui/components';
import { Filter as FilterType } from '../../types';
import { Filter } from './components';

type FiltersSidebarProps = {
  filters: FilterType[];
};

export const FiltersSidebarComponent = ({ filters }: FiltersSidebarProps) => {
  const [isSiderCollapsed, setIsSiderCollapsed] = useState(false);

  return (
    <div
      className={cx(
        'min-w-[300px] w-[300px] max-h-screen sticky top-0 overflow-y-auto transition-all duration-300',
        isSiderCollapsed && 'w-[65px] min-w-[65px] overflow-hidden',
      )}
    >
      <div className="p-2 flex justify-end sticky top-0 bg-white z-10">
        <Button
          icon={
            <DoubleLeftOutlined
              className={cx(
                'rotate-0 transition-transform duration-300',
                isSiderCollapsed && 'rotate-180',
              )}
            />
          }
          type="text"
          onClick={() => setIsSiderCollapsed(!isSiderCollapsed)}
        />
      </div>
      <ul
        className={cx(
          'list-none px-2 py-0 m-0 duration-150',
          isSiderCollapsed ? 'opacity-0' : 'opacity-100 delay-300',
        )}
      >
        {filters.map((filter, index) => (
          <Filter key={filter.title} filter={filter} isFirst={index === 0} />
        ))}
      </ul>
    </div>
  );
};

export const FiltersSidebar = memo(FiltersSidebarComponent, (prevProps, nextProps) => {
  return prevProps.filters === nextProps.filters;
});
